// extracted by mini-css-extract-plugin
module.exports = {"rateCardPage":"RateCardPage_rateCardPage__ZOrv-","dashboardRateCardBlock":"RateCardPage_dashboardRateCardBlock__2_hgg"};